import React from 'react';
import OrdersList from 'pages/orders/OrdersList';


const OrdersMDI: React.FC = () => {
  const defaultFilter = {
    customer_group_id: {
      field: 'customer_group_id',
      value: '164',
      conditionType: 'in' as AllowedConditionType
    },
    grand_total: {
      field: 'grand_total',
      value: '0',
      conditionType: 'neq' as AllowedConditionType
    }
  };

  return (
    <OrdersList
      pageTitle="Orders MDI"
      defaultFilter={defaultFilter}
    />
  );
};

export default OrdersMDI;
